<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <mentee-sidebar-menu :show_menu="false" :show_back_button="true"  back_link="menteeReports" />
      <div class="content-wrapper"  style="padding-left: 165px;">
        <div class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>

          <div>
            <iframe id="pdf-frame" style="display: none;""></iframe>
            <div class="my-3"></div>

            <div style="width: 70%; float: left; text-align: left; ">
              <h3 class="d-inline heading text-uppercase">Competency Progress</h3>
            </div>

            <div style="width: 30%; float: right; text-align: right; " >
              <div class="pl-2"  style="margin-top: 2px; float: right;" @click="shareButtonModal()">
              <img class="" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" />
              </div>
              <div class="pl-2" style="float: right; margin-right: 10px;"><i class="fa fa-print cursor-pointer" aria-hidden="true" @click="printFunc()" style="font-size: 30px; padding-top: 0px; "></i></div>
              <div class="pl-2" style="float: right; margin-right: 10px; margin-top: 2px;" @click="downloadFunc()">
              <img class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" />
              </div>
              <div style="clear: both;"></div>
            </div> 

            <div style="clear: both;"></div>

          </div>
          <div class="border-bottom mt-1 mb-2"></div>
         
       <!-- Filter Section -->
          <div class="row">
          <div class="col-md-8 offset-md-2">         
            
            
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down "></i></b-navbar-toggle>
              <b-collapse id="nav-collapse" is-nav>
              <div class="text-center h5 search-wrapper col-12">
                {{ pathwayName }}
              </div>

              </b-collapse>
            </b-navbar>
        </div>
      </div>

          <div style="clear: both;"></div>
          

    <div class="col-md-12 mb-2" v-for="option in 3" v-if="loading == true">
      <div class="col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3" style="margin-top: 10px;">
        <div class="row row align-items-center">
          <div class="col-7">
            <div class="cp-title col-4" style="text-align: left;"><PuSkeleton :count="1" width=""></PuSkeleton></div>
            <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="cp-text col-7"><PuSkeleton :count="1"></PuSkeleton></div>
            <div class="cp-text col-6"><PuSkeleton :count="1"></PuSkeleton></div>
          </div>
          <div class="col-5 " style="text-align:right; padding-right: 50px"> 
            <PuSkeleton circle height="120px" width="120px" :count="1"></PuSkeleton>
          </div>
        </div>
      </div>
    </div>

          <div class="col-md-12 mb-2">
            <div v-if="isOverviewVisible && loading == false" class="col-md-8 offset-md-2 border shadow float-left subtask-list-layout pt-1 px-3" style="margin-top: 10px;">
            <div class="row row align-items-center">
              <div class="col-7">
                <div class="cp-title" style="text-align: left;">Overview</div>
                <div class="cp-text">Total Tasks in List: {{ overviewTotalTaskCount }}</div>
                <div class="cp-text">Total Tasks Competent: {{ overviewTotalCompetentTaskCount }}</div>
                <div class="cp-text">Total Time Submitted: {{ calchoursonly(overviewTotaltime) }}</div>
                <div class="cp-text">
                  Remaining Tasks: {{ overviewTotalRemainingTaskCount }}
                  <a href="javascript:void(0);" class="help-txt ml-2 text-uppercase font-weight-bold branding_text_color" @click="displayOverviewRemainingTasks(overviewTotalRemainingTaskCount, overviewAllRemainingIds)" >view all</a>
                </div>
              </div>
              <div class="col-5">                  
                        <vc-donut
                            background="white" foreground="grey"
                            :size="100" unit="px" :thickness="30"              
                            :sections="chartDataItems" :total="100"
                            :start-angle="0" :auto-adjust-text-size="true" >
                      <h1>{{competentPercentValue}}%</h1>
                      </vc-donut>
                </div>
            </div>
            </div>
            <div style="clear: both;"></div>
          </div>


          <div class="col-md-12 mb-2" v-for="(subtask, sindex) in subtasks" :key="sindex">
            <div class="col-md-8 offset-md-2 shadow border float-left subtask-list-layout pt-1 px-3">
             <div class="row row align-items-center">
              <div class="col-7">
                <div class="cp-title" style="text-align: left;">{{ subtask.name }}</div>
                <div class="cp-text">Total Tasks in Section: {{ subtask.subtask_total_stats.totalTaskCount }}</div>
                <div class="cp-text">Total Tasks Competent: {{ subtask.subtask_total_stats.totalCompetentTaskCount }}</div>
                <div class="cp-text">Total Time Submitted: {{ calchoursonly(subtask.totalTime) }}</div>
                <div class="cp-text">
                  Remaining Tasks: {{ subtask.subtask_total_stats.totalRemainingTaskCount }}
                  <a href="javascript:void(0);" class="help-txt ml-2 text-uppercase font-weight-bold branding_text_color" @click="displayRemainingTasks(subtask.name, subtask.subtask_total_stats.totalRemainingTaskCount, subtask.subtask_total_stats.viewAllRemainingIds)" >view all</a>
                </div>
              </div>


               <div class="col-5" float-left>
                  <div class="cp-toggle-icon">
                    <b-link v-b-toggle="'collapse-' + subtask.id" @click="getFontIcon(subtask.id)">
                      <i class="fa fa-angle-down" :id="'angle-'+ subtask.id" aria-hidden="true"></i>
                    </b-link>
                  </div>
                        <vc-donut
                            background="white" foreground="grey"
                            :size="100" unit="px" :thickness="30"              
                            :sections="subtask.competent_percent" :total="100"
                            :start-angle="0" :auto-adjust-text-size="true" >
                      <h1>{{subtask.competent_percent[0].value}}%</h1>
                      </vc-donut>
                </div>
              </div>
              <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2">
                <div v-if="subtask.headings.length > 0" v-for="(heading, index) in subtask.headings" :key="index" class="cp-heading-lists">
                  <div v-if="heading.name != 'NULL' && heading.id != 99999">
                    <div class="row cp-heading-title">
                      <div class="col-12" style="font-size: 16px;">{{ heading.name }}</div>
                    </div>
                    <div class="row px-3 heading-tasks" v-if="heading.tasks.length > 0" v-for="(task, tindex) in heading.tasks" :key="tindex">
                      <div class="col-12 cp-task-desc">{{ (tindex + 1)  + '. ' + task.description }}</div>
                      <div :class="'col-12 ' + getRatedClass(task.three_plus_rated_count) + ' text-right pr-5'">{{ task.three_plus_rated_count }} Reps Rated 3+</div>
                      <div class="col-12 cp-see-all-reps text-right pr-5">
                        <a href="javascript:void(0);" @click="reportViewTaskRepitition(task.id, task.description, subtask.name, heading.name)" class="progress_item_link branding_text_color font-weight-bold">See All Task Reps  <img  v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="heading.id != 99999" >
                    <div v-if="heading.tasks.length > 0">
                      <div class="row px-3 heading-tasks" v-for="(task, tindex) in heading.tasks" :key="tindex">
                        <div class="col-12 text-muted">{{ (tindex + 1)  + '. ' + task.description }}</div>
                        <div :class="'col-12 ' + getRatedClass(task.three_plus_rated_count) + ' text-right pr-5'">{{ task.three_plus_rated_count }} Reps Rated 3+</div>
                        <div class="col-12 cp-see-all-reps text-right pr-5">
                          <a href="javascript:void(0);" @click="reportViewTaskRepitition(task.id, task.description, subtask.name, '')" class="progress_item_link branding_text_color font-weight-bold">See All Task Reps  <img  v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>  
            </div>
          <!--  <div class="col-md-5 float-left subtask-list-layout">
               
            </div>  -->
            <div style="clear: both;"></div>
          </div>

          <OverviewRemainingTasks
            :isModalVisible="isOverviewRemainingModalVisible"
            :tasklistId="taskListID"
            ref="overview_tasks"
            @close="isOverviewRemainingModalVisible = false">
          </OverviewRemainingTasks>
          <ViewRemainingTasks
            :isModalVisible="isViewRemainingModalVisible"
            :tasklistId="taskListID"
            ref="remaining_tasks"
            @close="isViewRemainingModalVisible = false">
          </ViewRemainingTasks>
          <ReportViewTaskRepitition
            :isModalVisible="isReportViewTaskModalVisible"
            :tasklistId="taskListID"
            :menteeId="menteeId"
            ref="report_view_task_reps"
            @close="isReportViewTaskModalVisible = false">
          </ReportViewTaskRepitition>
        </div>
      </div>
    </div>


    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding" style="color: #68C47E; text-align: center; margin-bottom: 15px;">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255"
                @keyup="checkEmail()"  />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
            <button :disabled="share_button_disable" v-on:click="shareButtonSubmit()"
                class="btn ma-blue-btn col-3 input-height-25 createBtn"
                style="line-height: 30px; border-radius: 10px;"><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
            <button disabled="true" class="btn ma-blue-btn col-lg-3"
                style="line-height: 30px; border-radius: 10px;"><b>Please wait...</b></button>
        </div>

        <!--div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Please wait...</b></button>
        </div-->

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import store from '../../store/store.js';
import OverviewRemainingTasks from '../manager/overview_remaining_tasks.vue';
import ViewRemainingTasks from '../manager/view_remaining_tasks.vue';
import ReportViewTaskRepitition from "../manager/report_task_view_repitition.vue";
import ShareReportModal from '../admin/create-tasklist-modal.vue';
import VeeValidate from 'vee-validate';
import MenteeSidebarMenu from '@/components/shared/mentee_sidebar_menu.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.use(Donut);

export default {
        data() {
          return {
            loading: false,
            taskLists: [],
            pathwayLists: [], 
            rep_task_list: '',
            rep_pathway: '',
            menteeLists: [],
            rep_mentee: '',
            menteeId: '',
            taskListID: '',
            subtasks: [],
            rep_days: '',
            overviewTotalTaskCount: 0,
            overviewTotalCompetentTaskCount: 0,
            overviewTotalRemainingTaskCount: 0,
            overviewAllRemainingIds: [],
            chartDataItems: [],
            competentPercentValue: '',
            sections: [
                { label: 'Red section', value: 100, color: 'red' },
                { label: 'Green section', value: 0, color: 'green' }                
              ],
            headings: [],
            tasks: [],
            isOverviewRemainingModalVisible: false,
            isViewRemainingModalVisible: false,
            isReportViewTaskModalVisible: false,
            isOverviewVisible: false,
            pdf_file_name: '',
            apiUrl: '',
            isModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            share_button_disable: true,
            overviewTotaltime: '',
            pathwayID: '',
            pathwayName: '',
          }
        },
        components: {
          UserMenu,
          GoBack,
          OverviewRemainingTasks,
          ViewRemainingTasks,
          ShareReportModal,
          ReportViewTaskRepitition,
          MenteeSidebarMenu
        },
        methods: {
          calchoursonly: function(minutes) {
              var hours = (minutes / 60);
              var rhours = Math.floor(hours);
              var min = (hours - rhours) * 60;
              var rminutes = Math.round(min);
              if(rminutes > 0) {
                  return rhours + " Hours " + rminutes + " Minutes ";
              }
              else {
                  return rhours + " Hours ";
              }
          },
          checkEmail: function () {
            if ((this.verrors.items.length === 0)) {
              this.share_button_disable = false;
            }
            else {
              this.share_button_disable = true;
            }
          },
          navigate(path) {
              router.push(path);
          },
            shareButtonSubmit: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  this.submit_text = 'Please wait...';
                  this.showWait = true;
                  this.insertReportTracking('Share');
                  if (this.rep_pathway) {
                      this.pathwayID = this.rep_pathway;
                  }
                  axios('/user-competency-report-email/' + this.pathwayID + '/' + this.menteeId + '/' + this.$store.state.user_accountid,
                     {
                       method: 'POST',
                       data:
                        {
                          email: this.share_email,
                        },
                     }
                   )
                  .then((resp) => {
                    this.share_email = '';
                    this.submit_text = 'Submit';
                    this.showWait = false;
                    this.showShareSuccess = true;
                    setTimeout(() => {
                        this.showShareSuccess = false;
                    }, 5000)
                    //this.isModalVisible = false;
                    //this.$emit('close');

                   })
                  .catch(error => {

                  });
                }
              });

            },
            shareButtonModal() {
              this.isModalVisible = true;
            },
            insertReportTracking: function(type) {
              axios('/desktop/reports-tracking',
                {
                  method: 'POST',
                  data: {            
                    account_id: this.$store.state.user_accountid,
                    type: type
                  },
                })
                .then(() => {          

                })
                .catch((error) => {
                   
                });

            },

            downloadFunc: function() {
              this.insertReportTracking('Download');
              this.showOverlay = true;
              if (this.rep_pathway) {
                  this.pathwayID = this.rep_pathway;
              }
              axios.get('/desktop-report/competency-report-pdf-for-pathway/' + this.pathwayID + '/' + this.menteeId + '/' + this.$store.state.user_accountid, {
              })
              .then(response =>  {
                this.showOverlay = false;
                this.pdf_file_name = response.data.pdf_file_name;
                var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
    
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], { type: "application/octetstream" });
    
                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", "competency_report.pdf");
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();

                return false;
              })
              .catch(function(error) {
                  console.log(error);
              });


            },
            printFunc: function() {
              this.showOverlay = true;
              if (this.rep_pathway) {
                  this.pathwayID = this.rep_pathway;
              }
              axios.get('/desktop-report/competency-report-pdf-for-pathway/' + this.pathwayID + '/' + this.menteeId + '/' + this.$store.state.user_accountid, {
              })
              .then(res =>  {
                this.pdf_file_name = res.data.pdf_file_name;
                this.showOverlay = false;
                fetch(this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name).then(function(response) {
                    return response.blob();
                }).then(function(myBlob) {
                    var objectURL = URL.createObjectURL(myBlob);
                    document.querySelector('#pdf-frame').src = '';
                    document.querySelector('#pdf-frame').src = objectURL;
                    objectURL = URL.revokeObjectURL(myBlob);
                }).then(
                    function() {
                        window.setTimeout(function() {
                            document.querySelector('#pdf-frame').contentWindow.print();
                        }, 1000)
                    });
                  return false;
              })
              .catch(function(error) {
                  console.log(error);
              });
            },
          filterCompetency() {
            this.loading = true;
            if (this.rep_pathway) {
                this.pathwayID = this.rep_pathway;
            }
            this.subtasks = [];

            axios.get('/desktop-report/mentee-tasklists-lists-competency-report-overivew/' + this.pathwayID + '/' + this.menteeId + '/' + this.$store.state.user_accountid, {
            })
            .then(response =>  {
                // console.log(response)
                this.overviewTotaltime = response.data.totalTime;
                this.overviewTotalTaskCount = response.data.totalTaskCount;
                this.overviewTotalCompetentTaskCount = response.data.totalCompetentTaskCount;
                this.overviewTotalRemainingTaskCount = response.data.totalRemainingTaskCount;
                this.overviewAllRemainingIds = response.data.viewAllRemainingIds;
                this.chartDataItems = response.data.competent_percent;
                //alert(this.chartDataItems[0].value)
                this.competentPercentValue = this.chartDataItems[0].value;
            })
            .catch(function(error) {
                console.log(error);
            });
            axios.get('/desktop-report/mentee-tasklists-lists-competency-report/' + this.menteeId + '/' + this.pathwayID + '/' + this.$store.state.user_accountid, {
            })
            .then(response =>  {
                this.loading = false; 
                if(response.data.length == 0) {
                    
                }
                else {
                    
                }
                this.isOverviewVisible = true;
                this.subtasks = response.data.taskList;

                // console.log(response)
            })
            .catch(function(error) {
                console.log(error);
            });
          },

          getTaskStats: function(subtask) {
            //alert(subtask.id);
            let subtaskId = subtask.id;
            var roles = this.$store.state.roles;
            var url = '';
            if((roles.indexOf('ROLE_MENTEE') > -1) || (roles.indexOf('ROLE_STUDENT') > -1)) {
                url = '/mobile/mentee-student-headings-tasks/86/'+ this.taskListID + '/' + subtaskId + '/' + this.$store.state.user_accountid;
            }
            else {
                //url = '/mobile/mentee-headings-tasks/' + this.menteeId + '/' + this.taskListID + '/' + subtaskId;
                url = '/mobile/mentee-headings-tasks-with-reps/' + this.menteeId + '/' + this.taskListID + '/' + subtaskId;
            }
            axios(url, {
                method: 'GET',
            })
            .then(response =>  {
                this.headings = response.data.heading;
                this.tasks = response.data.task;
            })
            .catch(error => {
                console.log(error);
            });
          },
          getRatedClass(count) {
            if (count > 2) {
                return 'cp-blue-reps';
            } else {
                return 'cp-gray-reps';
            }
          },
          reportViewTaskRepitition: function(taskId, taskDescription, subtaskName, headingName) {
            this.isReportViewTaskModalVisible = true;
            this.$refs.report_view_task_reps.getTaskItem(taskId, taskDescription, subtaskName, headingName);
          },
          displayRemainingTasks(subtaskTitle, remainingCount, remainingIds) {
            this.isViewRemainingModalVisible = true;
            this.$refs.remaining_tasks.getTaskItem(subtaskTitle, remainingCount, remainingIds);
          },
          displayOverviewRemainingTasks(remainingCount, remainingIds) {
            this.isOverviewRemainingModalVisible = true;
            this.$refs.overview_tasks.getTaskItem(remainingCount, remainingIds, this.rep_pathway);
          },
          getFontIcon(id) {
            if (document.getElementById('collapse-' + id).style.display == "") {
              document.getElementById('angle-'+ id).className = "fa fa-angle-down";
            } else {
              document.getElementById('angle-'+ id).className = "fa fa-angle-up";
            }
          }
        },
        created: function () {
          this.apiUrl = process.env.API_ENDPOINT;
          axios.get('/mobile/mentee/pathways', {
            params: {
              account_id: this.$store.state.user_accountid, 
            }
          })
          .then(response =>  {    
            this.loading = false; 
            this.menteeId = response.data.menteeId;
            var Lists = response.data.pathwayLists;
            for(var j=0; j<Lists.length; j++) {
              this.pathwayLists.push({
                'value': Lists[j].value,
                'text': Lists[j].display
              });
            }
            if(this.pathwayLists.length > 0) {
              this.rep_pathway = this.pathwayLists[0].value;
              this.pathwayName = this.pathwayLists[0].text;
              this.filterCompetency();
            }
          })
          .catch(function(error) {
              console.log(error);
          });

        }
    } 

</script>

<style scoped>
  .back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
  }
  .cp-text {
    font-size: 14px;
    padding: 2px 0px 2px 0px;
  }
  .cp-title {
    font-size: 16px;
    font-weight: bold;
    padding: 5px 0px 10px 0px;
  }
  .subtask-list-layout {
    background-color: #FFF;
    border-radius: 10px;
    padding: 10px 0 10px 10px;
    margin-bottom: 10px
  }
  .subtask-list-layout h1 {
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
    margin-top: 25px;
  }
  .report-line-separator {
    border-bottom: 1px solid #A6A6A6;
  }  
  .cp-toggle-icon {
    text-align: right;
    font-size: 26px;
    font-weight: bold;
    margin-right: 10px;
    margin-top: -2px;
  }
  .cp-heading-lists .row{
    margin-bottom: 10px;
  }
  .cp-heading-title {
    color: #7F7F7F;
    font-size: 14px;
    font-weight: 900;
    padding: 0;
  }
  .cp-blue-reps {
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
  }
  .cp-gray-reps {
    color: #707070;
    text-align: right;
    padding-right: 90px;
    margin-bottom: 5px;
  }
  .cp-see-all-reps {
    color: #707070;
    text-align: right;
    padding-right: 70px;
    margin-bottom: 10px;
  }
  .cp-filter-label {
    font-weight: bold;
  }
  .cp-task-desc {
    padding:0 50px;
    margin-bottom: 10px;
  }
  h1{
    color: #707070;
  }
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}
.print-section {
  font-family: 'bebas-neue-pro', sans-serif;
}
.begin-course-button {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px; 
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}

.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}

.rounded-pill {
    padding-left: 3rem!important;
    padding-right: 3rem!important;
  
}
@media (max-width: 1480px) {
  .rounded-pill {
    padding-left: 1.5rem!important;
    padding-right: 1.5rem!important;
  }
}
.heading-tasks {
  border-bottom: 1px solid #dee2e6 !important;
  margin-left: 5px;
  margin-right: 5px;
}
.fa-angle-down, .fa-angle-up {
  color: #00ACEE !important;
}

</style>



// WEBPACK FOOTER //
// src/components/mentee/competency_report.vue